import {type PIXI} from '@colonist/pixi'
import {UIGameTimedAnimation} from './UIGameTimedAnimation.ts'

interface FlickerAnimationOptions {
    minOpacity: number
    maxOpacity: number
    speed: number
}

export class UIGameFlickerAnimation extends UIGameTimedAnimation {
    protected readonly forceEnableAnimation: boolean = true
    protected readonly options: FlickerAnimationOptions

    constructor(viewToAnimate: PIXI.Container, animationDuration: number = 2000, options?: FlickerAnimationOptions) {
        super(animationDuration)
        this.viewToAnimate = viewToAnimate
        this.options = options ?? UIGameFlickerAnimation.getDefaultOptions()
    }

    updateAnimation(deltaTime: number, elapsedMS: number) {
        const {minOpacity, maxOpacity, speed} = this.options

        const animationProgress = (this.totalElapsedMS / 1000) * speed
        const opacityRange = maxOpacity - minOpacity
        const sineWaveValue = Math.sin(animationProgress * Math.PI * 2 - Math.PI / 2)
        const opacityOffset = (sineWaveValue * opacityRange + opacityRange) / 2
        const currentOpacity = minOpacity + opacityOffset

        this.viewToAnimate.alpha = currentOpacity
    }

    resetToDefaultState(): void {
        this.viewToAnimate.alpha = this.options.maxOpacity
    }

    private static getDefaultOptions(): FlickerAnimationOptions {
        return {
            minOpacity: 0.5,
            maxOpacity: 1,
            speed: 1.2,
        }
    }
}
